<template>
  <footer class="footer">
    <div class="row">
      <div class="col-md-4 hidden-sm hidden-xs text-center">
      </div>

      <div class="col-xs-12 col-md-4 text-center">
        <div class="row">
          <div class="col-xs-7 text-right">
            Copyright <b>ideXlab</b>, Inc. {{year}}
          </div>
          <div class="col-xs-5 text-left" v-if="!$user.isSe()">
            <span>Version</span>
            <span class="text-info">{{version}}</span>
          </div>
          <div class="col-xs-5 text-left" v-else>
            <span>LEA Version</span>
            <span class="text-success">{{leaVersion}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 hidden-sm hidden-xs text-center" >
        <template v-if="$route.meta.tour && !$user.isFreeTrial()">
          <div>
            <span id="takeTour" role="button" @click="startTour" class="btn btn-xs font-bold" :class="$user.isSe()?'btn-success':'btn-info'">
            <i class="fa fa-question-circle"></i> Take a tour
              </span>
            <Tour ref="tour"></Tour>
          </div>
        </template>
      </div>
    </div>
  </footer>
</template>
<style scoped>
  .fixed-footer .footer {
    background-color: #ffffff9e;
    z-index: 500;
  }
</style>
<script>
import Tour from './tour/Tour'
export default {
  name: 'FooterCo',
  components: {Tour},
  data () {
    return {
      version: process.env.VERSION,
      leaVersion: process.env.LEA_VERSION,
      year: new Date().getFullYear()
    }
  },
  methods: {
    startTour: function () {
      this.$refs.tour.start()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FooterCo.vue